export default __webpack_public_path__ + "locales/nl/ConnectDialog.json?hash=3968d13c5d4d849f4ce5dbcb7742f7e1";